import { render, staticRenderFns } from "./PointHistory.vue?vue&type=template&id=76361a4f&scoped=true&"
import script from "./PointHistory.vue?vue&type=script&lang=js&"
export * from "./PointHistory.vue?vue&type=script&lang=js&"
import style0 from "./PointHistory.vue?vue&type=style&index=0&id=76361a4f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76361a4f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VContainer})
